import { useContext } from 'react';
import useAppQuery from 'hooks/useAppQuery';
import API from 'services/API';
import {
  enableQuery,
  getTimezoneDateString,
  prepareAllPropertyUids,
} from 'utils/analytics/analyticsUtils';
import useAppUser from '../../../hooks/useAppUser';
import AnalyticsContext from '../AnalyticsContext';
import {
  AnalyticsKeyMetric,
  AnalyticsKeyMetricsResponse,
} from './types/AnalyticsKeyMetrics.types';

const useKeyMetricsData = () => {
  const { filter, allProperties } = useContext(AnalyticsContext);
  const { agencyUid, agency, isOwner, userUid } = useAppUser();

  const {
    data: keyMetrics,
    isLoading: isKeyMetricsLoading,
    error: keyMetricsError,
  } = useAppQuery(
    [
      'getKeyMetrics',
      filter?.range?.startDate,
      filter?.range?.endDate,
      filter?.currency,
      filter?.propertyUid,
      filter?.channel,
      filter?.range,
      filter?.timeReference,
      agencyUid,
      isOwner,
    ],
    async () => {
      const { dateType, currency, propertyUid, channel, range } = filter;
      const metrics = [
        AnalyticsKeyMetric.RENTAL_REVENUE,
        AnalyticsKeyMetric.NIGHTS_BOOKED,
        AnalyticsKeyMetric.OCCUPANCY_RATE,
        AnalyticsKeyMetric.AVERAGE_DAILY_RATE,
        AnalyticsKeyMetric.REV_PAR,
      ];

      if (isOwner) {
        metrics.push(AnalyticsKeyMetric.OWNER_REVENUE);
      }
      const response = await API.post<AnalyticsKeyMetricsResponse>(
        `/api/internal/analytics/key-metrics`,
        {
          agencyUid,
          dateType,
          // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
          from: getTimezoneDateString(range.startDate, agency?.timeZone),
          // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
          to: getTimezoneDateString(range.endDate, agency?.timeZone),
          currency,
          propertyUids: prepareAllPropertyUids({
            allProperties,
            currency,
            propertyUid,
          }),
          channel,
          metrics,
          ownerUid: isOwner ? userUid : undefined,
        },
      );
      return response.data.metricsValues;
    },
    {
      enabled: enableQuery({
        // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        agencyUid,
        filter,
        allProperties,
      }),
    },
  );

  return {
    keyMetrics,
    isKeyMetricsLoading,
    keyMetricsError,
  };
};

export default useKeyMetricsData;
